// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { Api } from "#/api";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class CwLandingpageTeaserModule extends ModuleBase {
  private count = 0;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get getColorClass() {
    let color = this.instance["color"];
    return color == "white" ? "white" : "black";
  }

  get checkTransparentHeader() {
    let transparentHeader = this.instance["transparent_header"];
    return transparentHeader == true ? "has-header-2" : "";
  }

  public created() {
    this.getCount();
  }

  public async getCount() {
    let result = await Api.conversionWorldService.getProductFilterCount(
      this.$store.page.page!.id
    );
    this.count = result.total;
  }

  get button1Link() {
    return "https://conversion-world.mercedes-benz.com/";
  }

  get button2Link() {
    return (
      "https://conversion-world.mercedes-benz.com/" +
      this.lang +
      "/" +
      this.country +
      "/auswahl-branche"
    );
  }
}
